// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-image {
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #f0f0f0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.hero-card-title3 {
  font-size: 20px;
  font-size: 15px;

  color: #77dd0d;
  margin-bottom: 20px;
  text-align: left;
  padding: 2%;
}
.hero-card {
  position: absolute;
  top: 50%;
  left: 20%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background-color: #001d4a;
  opacity: 100%;
  border-radius: 0px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.hero-card-title1 {
  font-size: 20px;
  color: #77dd0d;
  margin-bottom: 20px;
  text-align: left;
  padding: 2%;
}

.hero-card-title {
  font-size: 45px;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
  text-align: left;
  margin-top: -10px;
}

.hero-card-description {
  font-size: 18px;
  color: white;
  margin-bottom: 90px;
  margin-left: -20px;
}

.learn-moree-btn {
  background-color: #77dd0d;
  color: white;
  padding: 10px 110px;
  top: -10%;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  position: relative;
}

.learn-moree-btn:hover {
  background-color: #005c00;
}

.scroll-btn {
  width: 20px !important;
  height: 20px !important;
  background-color: #90f011;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.scroll-btn.active {
  transform: scale(1.2) !important;
  opacity: 1 !important;
}

.scroll-btn:hover {
  transform: scale(1.3) !important;
  background-color: #007e01 !important;
}

.scrolling-buttons {
  position: absolute;
  margin-bottom: -90px;
  display: flex;
  gap: 15px;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
}

.dynamic-box {
  position: absolute;
  bottom: 15%;
  left: 70.7%;
  width: 300px;
  background-color: #001d4a;
  opacity: 100%;
  color: white;

  padding: 20px;
  border-radius: 10px;
}
.dynamic-box-1 {
  background-color: #cbffef9e;
  color: #001d4a;
}

.dynamic-box-2 {
  background-color: #1140da49;
  color: white;
}

.dynamic-box-3 {
  background-color: #020b0f5d;
  color: white;
}

.dynamic-box-4 {
  background-color: #dbdb296a;
  color: white;
}

.box-content {
  font-size: 25px;
  line-height: 1.5;
}

.HomeServices {
  margin-top: -60px;
}
.HomeServices3 {
  margin-bottom: -80px;
  margin-top: -100px;
}

@media screen and (max-width: 1200px) {
  .hero-card {
    width: 1100px;
    max-width: 350px;
    height: 200px;
    padding: 80px 20px;
    bottom: 10%;
    top: auto;
    left: 5%;
    bottom: 0%;
    transform: translateX(-5%);
  }
  .hero-image {
    position: relative;
    padding: 10px 10px;
    width: 100%;
    height: 100vh;
    background-color: #f0f0f0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 40%;
  }

  .hero-card-title3 {
    font-size: 20px;
    font-size: 15px;

    color: #77dd0d;
    margin-bottom: 20px;
    text-align: left;
    padding: 2%;
  }
  .hero-card-title1 {
    font-size: 15px;

    color: #77dd0d;
    margin-bottom: 20px;
    text-align: left;
    padding: 2%;
  }
  .hero-card-title {
    font-size: 30px;
    font-weight: bold;
    color: white;
    margin-bottom: 20px;
    text-align: left;
  }

  .hero-card-description {
    font-size: 18px;
    color: white;
    margin-bottom: 90px;
  }
  .hero-card-description {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .learn-moree-btn {
    font-size: 16px;
    font-weight: 200%;
    padding: 10px 115px;
    height: 25%;
    margin-top: 50px;
    margin-left: -20px;
    z-index: 100%;
  }

  @media screen and (max-width: 1200px) {
    .scrolling-buttons {
      top: 5px;
      bottom: auto;
      gap: 8px;
    }

    .scroll-btn {
      width: 8px !important;
      height: 8px !important;
    }

    .scroll-btn.active {
      transform: scale(1.1);
    }

    .scroll-btn:hover {
      transform: scale(1.2);
    }
    @media (max-width: 768px) {
      .dynamic-box {
        display: none;
        position: relative;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 90%;
        font-size: 18px;
        padding: 15px;
        border-radius: 8px;
      }

      .dynamic-box-1,
      .dynamic-box-2,
      .dynamic-box-3,
      .dynamic-box-4 {
        font-size: 16px;
      }

      .box-content {
        font-size: 20px;
        line-height: 1.4;
      }

      .HomeServices {
        margin-top: -230px;
      }

      .HomeServices3 {
        margin-bottom: -40px;
        margin-top: -100px;
      }

      .hero-card-title1 {
        margin-bottom: -50px;
      }
      .hero-card {
        position: absolute;
        top: 65%;
        padding-top: 30px;
      }

      .learn-moree-btn {
        background-color: #77dd0d;
        color: white;
        padding: 10px 110px;
        top: 0%;
        border-radius: 5px;
        font-weight: bold;
        border: none;
        cursor: pointer;
        position: relative;
        margin-top: 10px;
      }

      .learn-moree-btn:hover {
        background-color: #005c00;
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;;EAEf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,YAAY;;EAEZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;;IAEf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;;IAEf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE;MACE,QAAQ;MACR,YAAY;MACZ,QAAQ;IACV;;IAEA;MACE,qBAAqB;MACrB,sBAAsB;IACxB;;IAEA;MACE,qBAAqB;IACvB;;IAEA;MACE,qBAAqB;IACvB;IACA;MACE;QACE,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,UAAU;QACV,eAAe;QACf,aAAa;QACb,kBAAkB;MACpB;;MAEA;;;;QAIE,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,gBAAgB;MAClB;;MAEA;QACE,kBAAkB;MACpB;;MAEA;QACE,oBAAoB;QACpB,kBAAkB;MACpB;;MAEA;QACE,oBAAoB;MACtB;MACA;QACE,kBAAkB;QAClB,QAAQ;QACR,iBAAiB;MACnB;;MAEA;QACE,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;QACnB,OAAO;QACP,kBAAkB;QAClB,iBAAiB;QACjB,YAAY;QACZ,eAAe;QACf,kBAAkB;QAClB,gBAAgB;MAClB;;MAEA;QACE,yBAAyB;MAC3B;IACF;EACF;AACF","sourcesContent":[".hero-image {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background-color: #f0f0f0;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.hero-card-title3 {\n  font-size: 20px;\n  font-size: 15px;\n\n  color: #77dd0d;\n  margin-bottom: 20px;\n  text-align: left;\n  padding: 2%;\n}\n.hero-card {\n  position: absolute;\n  top: 50%;\n  left: 20%;\n  transform: translate(-50%, -50%);\n  width: 300px;\n  height: 300px;\n  background-color: #001d4a;\n  opacity: 100%;\n  border-radius: 0px;\n  padding: 20px;\n  text-align: center;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.hero-card-title1 {\n  font-size: 20px;\n  color: #77dd0d;\n  margin-bottom: 20px;\n  text-align: left;\n  padding: 2%;\n}\n\n.hero-card-title {\n  font-size: 45px;\n  font-weight: bold;\n  color: white;\n  margin-bottom: 10px;\n  text-align: left;\n  margin-top: -10px;\n}\n\n.hero-card-description {\n  font-size: 18px;\n  color: white;\n  margin-bottom: 90px;\n  margin-left: -20px;\n}\n\n.learn-moree-btn {\n  background-color: #77dd0d;\n  color: white;\n  padding: 10px 110px;\n  top: -10%;\n  border-radius: 5px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  position: relative;\n}\n\n.learn-moree-btn:hover {\n  background-color: #005c00;\n}\n\n.scroll-btn {\n  width: 20px !important;\n  height: 20px !important;\n  background-color: #90f011;\n  border-radius: 50%;\n  border: none;\n  cursor: pointer;\n  transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.scroll-btn.active {\n  transform: scale(1.2) !important;\n  opacity: 1 !important;\n}\n\n.scroll-btn:hover {\n  transform: scale(1.3) !important;\n  background-color: #007e01 !important;\n}\n\n.scrolling-buttons {\n  position: absolute;\n  margin-bottom: -90px;\n  display: flex;\n  gap: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  flex-direction: row;\n}\n\n.dynamic-box {\n  position: absolute;\n  bottom: 15%;\n  left: 70.7%;\n  width: 300px;\n  background-color: #001d4a;\n  opacity: 100%;\n  color: white;\n\n  padding: 20px;\n  border-radius: 10px;\n}\n.dynamic-box-1 {\n  background-color: #cbffef9e;\n  color: #001d4a;\n}\n\n.dynamic-box-2 {\n  background-color: #1140da49;\n  color: white;\n}\n\n.dynamic-box-3 {\n  background-color: #020b0f5d;\n  color: white;\n}\n\n.dynamic-box-4 {\n  background-color: #dbdb296a;\n  color: white;\n}\n\n.box-content {\n  font-size: 25px;\n  line-height: 1.5;\n}\n\n.HomeServices {\n  margin-top: -60px;\n}\n.HomeServices3 {\n  margin-bottom: -80px;\n  margin-top: -100px;\n}\n\n@media screen and (max-width: 1200px) {\n  .hero-card {\n    width: 1100px;\n    max-width: 350px;\n    height: 200px;\n    padding: 80px 20px;\n    bottom: 10%;\n    top: auto;\n    left: 5%;\n    bottom: 0%;\n    transform: translateX(-5%);\n  }\n  .hero-image {\n    position: relative;\n    padding: 10px 10px;\n    width: 100%;\n    height: 100vh;\n    background-color: #f0f0f0;\n    overflow: hidden;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    margin-bottom: 40%;\n  }\n\n  .hero-card-title3 {\n    font-size: 20px;\n    font-size: 15px;\n\n    color: #77dd0d;\n    margin-bottom: 20px;\n    text-align: left;\n    padding: 2%;\n  }\n  .hero-card-title1 {\n    font-size: 15px;\n\n    color: #77dd0d;\n    margin-bottom: 20px;\n    text-align: left;\n    padding: 2%;\n  }\n  .hero-card-title {\n    font-size: 30px;\n    font-weight: bold;\n    color: white;\n    margin-bottom: 20px;\n    text-align: left;\n  }\n\n  .hero-card-description {\n    font-size: 18px;\n    color: white;\n    margin-bottom: 90px;\n  }\n  .hero-card-description {\n    font-size: 18px;\n    margin-bottom: 15px;\n  }\n\n  .learn-moree-btn {\n    font-size: 16px;\n    font-weight: 200%;\n    padding: 10px 115px;\n    height: 25%;\n    margin-top: 50px;\n    margin-left: -20px;\n    z-index: 100%;\n  }\n\n  @media screen and (max-width: 1200px) {\n    .scrolling-buttons {\n      top: 5px;\n      bottom: auto;\n      gap: 8px;\n    }\n\n    .scroll-btn {\n      width: 8px !important;\n      height: 8px !important;\n    }\n\n    .scroll-btn.active {\n      transform: scale(1.1);\n    }\n\n    .scroll-btn:hover {\n      transform: scale(1.2);\n    }\n    @media (max-width: 768px) {\n      .dynamic-box {\n        display: none;\n        position: relative;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 90%;\n        font-size: 18px;\n        padding: 15px;\n        border-radius: 8px;\n      }\n\n      .dynamic-box-1,\n      .dynamic-box-2,\n      .dynamic-box-3,\n      .dynamic-box-4 {\n        font-size: 16px;\n      }\n\n      .box-content {\n        font-size: 20px;\n        line-height: 1.4;\n      }\n\n      .HomeServices {\n        margin-top: -230px;\n      }\n\n      .HomeServices3 {\n        margin-bottom: -40px;\n        margin-top: -100px;\n      }\n\n      .hero-card-title1 {\n        margin-bottom: -50px;\n      }\n      .hero-card {\n        position: absolute;\n        top: 65%;\n        padding-top: 30px;\n      }\n\n      .learn-moree-btn {\n        background-color: #77dd0d;\n        color: white;\n        padding: 10px 110px;\n        top: 0%;\n        border-radius: 5px;\n        font-weight: bold;\n        border: none;\n        cursor: pointer;\n        position: relative;\n        margin-top: 10px;\n      }\n\n      .learn-moree-btn:hover {\n        background-color: #005c00;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
